import { useMergeRefs } from '@floating-ui/react';
import { useMask } from "../../hooks/useMask.js";
import { Input } from "../input/Input.js";
import { jsx as _jsx } from "react/jsx-runtime";
const formatOptions = {
  mask: '##00 0000 0000 0000 0000 00',
  lazy: true,
  prepareChar: str => str.toUpperCase(),
  definitions: {
    '#': /[A-Z]/u
  }
};
export function InputIban({
  value,
  onValueChange,
  inputRef,
  ...props
}) {
  const maskRef = useMask({
    value,
    onValueChange,
    options: formatOptions
  });
  const mergedRef = useMergeRefs([inputRef ?? null, maskRef]);
  return /*#__PURE__*/_jsx(Input, {
    ...props,
    label: "IBAN",
    placeholder: "DE## #### #### #### #### ##",
    inputRef: mergedRef ?? undefined,
    type: "text"
  });
}